import type { ActKc2Data } from 'gql/graphql';
import { formatDateToLocale } from 'utils';

import type React from 'react';
import { useMemo } from 'react';

import Style from './ActKc2RequisitesBar.module.css';

interface IActKc2RequisitesBar {
    item?: ActKc2Data | null;
    suppressCorrectionTitle?: boolean;
    hasBottomBorder?: boolean;
}

export const ActKc2RequisitesBar: React.FC<IActKc2RequisitesBar> = (props) => {
    const { item, suppressCorrectionTitle, hasBottomBorder } = props;

    const title = useMemo(() => {
        const typeTitle = item?.isCorrection ? 'корректировочного' : 'исходного';

        return `Реквизиты ${suppressCorrectionTitle ? '' : typeTitle} Акта КС-2`;
    }, [item?.isCorrection, suppressCorrectionTitle]);

    const items = useMemo(() => {
        const objectItem = {
            title: 'Объект',
            value: item?.object.name,
        };

        return [
            ...(!item?.isCorrection ? [objectItem] : []),
            {
                title: 'Номер Акта КС-2',
                value: item?.isCorrection ? item?.fullNumber : item?.number,
            },
            {
                title: 'Дата составления Акта',
                value: formatDateToLocale(item?.createdAt),
            },
            {
                title: 'Отчетный период',
                value: `${formatDateToLocale(item?.reportingStartDate)} - ${formatDateToLocale(
                    item?.reportingFinishDate,
                )}`,
            },
        ];
    }, [item]);

    return (
        <div className={`${Style.actKc2RequisitesBar} ${hasBottomBorder ? Style.actKc2RequisitesBarBottom : ''}`}>
            <div className={Style.actKc2RequisitesBarTitle}>{title}</div>
            <div className={Style.actKc2RequisitesBarItems}>
                {items.map((reqItem, index, arr) => (
                    <div
                        className={`${Style.actKc2RequisitesBarItem} ${
                            index < arr.length - 1 ? Style.actKc2RequisitesBarItemSplit : ''
                        }`}
                        key={index}
                    >
                        <div className={Style.actKc2RequisitesBarItemTitle}>{reqItem.title}:</div>
                        <div className={Style.actKc2RequisitesBarItemValue}>{reqItem.value}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

ActKc2RequisitesBar.displayName = 'ActKc2RequisitesBar';
